/**
 * Shared layout constants used by visual renderers.
 *
 * Values match the judo-ui-react-template so that divider/spacer visuals
 * align pixel-for-pixel with the legacy output.
 */

/**
 * Fixed height for divider and spacer rows.
 * Matches the template's DIVIDER_HEIGHT constant.
 */
export const DIVIDER_HEIGHT = "2rem";
